<ng-container
    *ngIf="(assignmentScheduleStateService.assignmentScheduleDetailsSubject | async) as assignmentScheduleDetails">


    <div class="d-flex gap-2 flex-wrap">
        <span class="badge badge-secondary p-2 d-flex gap-1">
            {{'assignmentSchedules.deadline' | transloco}}:
            <b>{{assignmentScheduleDetails.to | date: "dd.MM.yy"}}</b>
        </span>

        <span class="badge badge-secondary p-2 d-flex gap-1" *ngIf="notAnsweredCount != null && notAnsweredCount > 0">
            {{'assignmentSchedules.answers.notAnwsweredCount' | transloco}}:
            <b>{{notAnsweredCount}}</b>
        </span>

        <span class="badge badge-success p-2 d-flex gap-1">
            {{'assignmentSchedules.answers.yesCount' | transloco}}:
            <b>{{yesCount}}</b>
        </span>

        <span class="badge badge-warning p-2 d-flex gap-1">
            {{'assignmentSchedules.answers.maybeCount' | transloco}}:
            <b>{{maybeCount}}</b>
        </span>

        <span class="badge badge-danger p-2 d-flex gap-1">
            {{'assignmentSchedules.answers.noCount' | transloco}}:
            <b>{{noCount}}</b>
        </span>
    </div>

</ng-container>